module.exports = __webpack_public_path__ + "img/logo_atlas.73ae5ae0.svg";